import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'app/shared/services/navigation.service';

@Component({
  selector: 'app-df-admin',
  templateUrl: './df-admin.component.html',
  styleUrls: ['./df-admin.component.scss']
})
export class DfAdminComponent implements OnInit {

  constructor(
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
  }

  countryNavigation() {
    this.navigationService.dfAdminManagemnt().adminlist().go();
  }

  chargesNavigation() {
    this.navigationService.dfVariableChargesManagemnt().chargelist().go();
  }

}
